import ImageWithFallback from '@/components/ui/ImageWithFallback'
import { LightSearchContext } from '@/contexts/LightSearchContext'
import { Badge, Text } from '@mantine/core'
import Image from 'next/image'
import Link from 'next/link'
import { useContext, useEffect, useState } from 'react'

import { ProductTemplate } from 'stoux-shared-types/models/product-template'

type Props = Partial<ProductTemplate> & {
    _highlightResult?: {
        title: {
            value: string
        }
    }
}

const SearchHit = ({
    handle,
    category,
    _highlightResult,
    title,
    thumbnail,
    barcode,
}: Props) => {


    
  const {
        onClearSearch,
    } = useContext(LightSearchContext)

    
    return (
        <Link role="link" href={`/p/${barcode}`} className="w-full" onClick={onClearSearch}>
            <div className="flex w-full p-4 transition-all duration-300 hover:bg-neutral-100 gap-x-4" >
                <section role="img">
                    <ImageWithFallback
                        src={
                            (thumbnail && thumbnail !== 'null' && thumbnail) ||
                            '/images/products/placeholder.png'
                        }
                        className="object-cover object-center rounded aspect-square"
                        width={48}
                        height={48}
                        alt={`Miniature de ${title}`}
                    />
                </section>

                <section role="content" className="flex flex-col flex-1 w-full">
                    <div role="title">
                        <Text
                            className="text-sm font-semibold capitalize border-none text-neutral-800"
                            dangerouslySetInnerHTML={{
                                __html: _highlightResult!.title.value,
                            }}
                        />
                    </div>
                 
                        <div
                        role="description"
                        className="flex flex-wrap mt-2 gap-x-2 gap-y-1"
                        >
                        {category?.mpath?.split('/').map((badge) => (
                            <Badge
                                size="xs"
                                variant="light"
                                className="capitalize"
                                color="orange"
                                key={badge}
                            >
                                {badge}
                            </Badge>
                        ))}
                    </div>
                  
                    
                </section>
            </div>
        </Link>
    )
}

export default SearchHit
